export default __webpack_public_path__ + "static/media/cyan-gradient.46493696.png";